import React, { Component } from 'react';
import WidgetModalForm from 'components/Modal/modalForm.component';
import Input from "components/Input/input.component";
import Table from "components/Table/table.component";
import FormatHelper from 'utils/formatHelper';

export default class VisualizarPdrPrestacao extends Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}

	getColumnsRestabelecimento = (isNotificacaoDaca) =>{
		let arrayColumns = [
			{ id: 0, title: "Especificação", property: "nomeItem" },
			{ id: 1, title: "Tipo", property: "tipoContratoDescricao" },
			{ id: 2, title: "Nº de Dias", property: "numDias" },
			{ id: 3, title: "Unidade", property: "tipoUnidade" },
			{ id: 4, title: "Quantidade", property: "quantidade" },
			{ id: 5, title: "Valor Unitário (R$)", property: "valorUnidade" },
			{ id: 6, title: "Valor Total (R$)", property: "valorTotal" },
		];

		if (isNotificacaoDaca) {
			arrayColumns.push({ id: 7, title: "Valor Atendido (R$)", property: "valorSugerido" })
		}

		return arrayColumns
	}

	getListaRecursosFormatada = (recursosRestabelecimentoList, recursosAssistenciaList) => {
		let recursosListModificada = [];

		let recursosList = recursosRestabelecimentoList!== null && recursosRestabelecimentoList.length > 0 ? recursosRestabelecimentoList :
		recursosAssistenciaList !== null && recursosAssistenciaList.length > 0 ? recursosAssistenciaList : [];

		recursosList.forEach(element => {
			let item = Object.assign({}, element);
			item.valorUnidade = FormatHelper.formatMoneyNumber(item.valorUnidade);
			item.valorTotal = FormatHelper.formatMoneyNumber(item.valorTotal)

			if(item.valorSugerido) {
				item.valorSugerido = FormatHelper.formatMoneyNumber(item.valorSugerido)
			}

			recursosListModificada.push(item);
		});

		return recursosListModificada;
	}

	render() {
		const {
			props: {
				isOpen,
				item,
				handleClose,
				isNotificacaoDaca
			},
		} = this;
		return (
			<WidgetModalForm
				textCancelar="Fechar"
				title="Visualizar"
				isOpen={isOpen}
				cancelar={handleClose}
				iconCancelar="fas fa-times"
			>
				<>
					<div className='row'>
						<label className='col-4'>
							<b>Meta:</b>
							{' '}
							{item.nomeMeta || ' -- '}
						</label>
						<label className='col-4'>
							<b>Nº de Beneficiados:</b>
							{' '}
							{item.numBeneficiados || ' -- '}
						</label>
					</div>

					<div className='row'>
						<label className='col-4'>
							<b>Nº de Dias:</b>
							{' '}
							{item.numDias || ' -- '}
						</label>
						<label className='col-4'>
							<b>Valor Total da Meta:</b>
							{' '}
							{item.valor || ' -- '}
						</label>
					</div>

					<div className='row'>
						<div className='col-md-12'>
							<label>
								<b>Justificativa:</b>
							</label>
							<div className='form-group'>
								<Input
									type='textarea'
									name='descricao'
									disabled={true}
									value={item.justificativa || ' -- '}
									rows='3'
									maxLength='255'
								/>
							</div>
						</div>
					</div>

					<div className='row'style={{marginTop: '10px'}}>	
							<label className='col-12'>
								<b>Lista de Itens:</b>
								{' '}
							</label>
						</div>

					<div className='row'style={{marginTop: '10px'}}>	
						<div className='col-12'>
							{(item.listaRecursoRestabelecimentoItens != null && item.listaRecursoRestabelecimentoItens.length > 0) || (item.listaRecursoAssistenciaItens != null && item.listaRecursoAssistenciaItens.length > 0) 
								?
									<Table
										columns={this.getColumnsRestabelecimento(isNotificacaoDaca)}
										data={this.getListaRecursosFormatada(item.listaRecursoRestabelecimentoItens, item.listaRecursoAssistenciaItens)}
										emptyMessage="Não há registros cadastrados."
										emptyColSpan={this.getColumnsRestabelecimento.length + 1}
									/>
									:
									<SemInformacoes/>
								}
						</div>
					</div>
				</>
			</WidgetModalForm>
		);
	}
}

const SemInformacoes = () => (
	<span>Não existem informações a serem exibidas.</span>
);
